import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  params: {
    page: 1,
    limit: 10,
  },
};

const reducers = {
  handleParams: (state, { payload }) => {
    state.params = payload?.fields;
    return state;
  },
  handleParamsFields: (state, { payload }) => {
    const field = payload?.field;
    state.params[field] = payload?.value;
    return state;
  },
};

const percentualEscrituracaoSlice = createSlice({
  name: "percentualEscrituracao",
  initialState: INITIAL_STATE,
  reducers,
});

const reducer = percentualEscrituracaoSlice.reducer;
export const actions = percentualEscrituracaoSlice.actions;
export default reducer;
